import React from "react";
import "./esgcircle.css";

export default function EsgCircle({ setMenu, showText, hideText }) {
	return (
		<div className="svg_box">
			<div className="svg-container">
				<svg
					id="eIcNqD9v6QR1"
					width="50vw"
					className="svg-circle"
					height="100%"
					viewBox="0 0 800 800"
					shapeRendering="geometricPrecision"
					textRendering="geometricPrecision"
					preserveAspectRatio="xMidYMid meet"
				>
					<circle
						cx="400"
						cy="400"
						r="350"
						fill="none"
						stroke="black"
						strokeWidth="2"
						strokeDasharray="5,5"
					/>
					<circle cx="400" cy="400" r="300" fill="#fff"></circle>

					<g
						className="arcs"
						id="arcs"
						transform=" translate(400 400) rotate(30) scale(1 -1)"
					>
						<path
							className="sustainability stroked-elements"
							d="M 0 0 L 150 -259.8076 A 300 300 0 0 0 -150 -261.8076 Z"
							fill="#899bbe"
							stroke="#1e4067"
							strokeWidth="1"
						/>
						<path
							className="strategy stroked-elements"
							d="M 0 0 L 300 0 A 300 300 0 0 0 150 -259.8076 Z"
							fill="#647ca8"
							stroke="#1e4067"
							strokeWidth="1"
						/>
						<path
							className="opportunity stroked-elements"
							d="M 0 0 L -150 -259.8076 A 300 300 0 0 0 -300 0 Z"
							fill="#425c92"
							stroke="#1e4067"
							strokeWidth="1"
						/>
						<path
							className="kooperationspartner stroked-elements"
							d="M 0 0 L -300 0 A 300 300 0 0 0 -150 259.8076 Z"
							fill="#3e5582"
							stroke="#1e4067"
							strokeWidth="1"
						/>
						<path
							className="status_quo stroked-elements"
							d="M 0 0 L -150 259.8076 A 300 300 0 0 0 150 259.8076 Z"
							fill="#d4dbe8"
							stroke="#1e4067"
							strokeWidth="1"
						/>
						<path
							className="reporting stroked-elements"
							d="M 0 0 L 150 259.8076 A 300 300 0 0 0 300 0 Z"
							fill="#aebcd3"
							stroke="#1e4067"
							strokeWidth="1"
						/>
						<text
							x="50"
							y="180"
							fill="white"
							fontSize="1.3em"
							fontWeight="400"
							className="font-alt-text"
							transform="
scale(+1,-1) rotate(-30)"
						>
							<tspan dy="0em">ESG Strategy</tspan>
						</text>
						<text
							className="sec_1_text"
							x="-50"
							y="180"
							fill="white"
							fontSize="1.3em"
							fontWeight="400"
							transform=" scale(+1,-1) rotate(-30)"
						>
							<tspan x="-150" dy="0">
								Financing
							</tspan>
							<tspan x="-165" dy="1.1em">
								Sustainability
							</tspan>
						</text>
						<text
							x="-300"
							y="10"
							fill="white"
							fontSize="1.3em"
							fontWeight="400"
							className="font-alt-text"
							transform="
scale(+1,-1) rotate(-30)"
						>
							<tspan x="-280" dy="0em">
								ESG Opportunist
							</tspan>
						</text>
						<text
							x="-200"
							y="-170"
							fill="white"
							fontSize="1.3em"
							fontWeight="400"
							className="font-alt-text"
							transform="
scale(+1,-1) rotate(-30)"
						>
							<tspan dy="0em">Kooperationspartner</tspan>
						</text>
						<text
							x="50"
							y="-170"
							fill="#1e4067"
							fontSize="1.3em"
							fontWeight="400"
							className="font-alt-text"
							transform="
scale(+1,-1) rotate(-30)"
						>
							<tspan dy="0em">ESG status quo</tspan>
						</text>
						<text
							x="80"
							y="-10"
							fill="#1e4067"
							fontSize="1.3em"
							fontWeight="400"
							className="font-alt-text"
							transform="
scale(+1,-1) rotate(-30)"
						>
							<tspan x="130" dy="0em">
								ESG Reporting
							</tspan>
							<tspan x="170" dy="1.1em">
								and
							</tspan>
							<tspan x="120" dy="1.1em">
								&nbsp;Communication
							</tspan>
						</text>
						<a
							onMouseOver={(e) => showText(e, "sustainability")}
							onMouseLeave={(e) => hideText(e, "sustainability")}
							onClick={(e) => setMenu("sustainability")}
						>
							<path
								className="sec_1_overlay path_overlay hover-tooltip"
								aria-describedby="tooltip-a"
								d="M 0 0 L 150 -259.8076 A 300 300 0 0 0 -150 -261.8076 Z"
								fill="transparent"
							/>
						</a>
						<a
							onMouseOver={(e) => showText(e, "strategy")}
							onMouseLeave={(e) => hideText(e, "strategy")}
							onClick={(e) => setMenu("strategy")}
						>
							<path
								className="sec_2_overlay path_overlay hover-tooltip"
								aria-describedby="tooltip-b"
								d="M 0 0 L 300 0 A 300 300 0 0 0 150 -259.8076 Z"
								fill="transparent"
							/>
						</a>
						<a
							onMouseOver={(e) => showText(e, "opportunity")}
							onMouseLeave={(e) => hideText(e, "opportunity")}
							onClick={(e) => setMenu("opportunity")}
						>
							<path
								className="sec_3_overlay path_overlay hover-tooltip"
								aria-describedby="tooltip-c"
								d="M 0 0 L -150 -259.8076 A 300 300 0 0 0 -300 0 Z"
								fill="transparent"
							/>
						</a>

						<a
							onMouseOver={(e) => showText(e, "kooperationspartner")}
							onMouseLeave={(e) => hideText(e, "kooperationspartner")}
							onClick={(e) => setMenu("kooperationspartner")}
						>
							<path
								className="sec_4_overlay path_overlay hover-tooltip"
								aria-describedby="tooltip-d"
								d="M 0 0 L -300 0 A 300 300 0 0 0 -150 259.8076 Z"
								fill="transparent"
							/>
						</a>
						<a
							onMouseOver={(e) => showText(e, "status_quo")}
							onMouseLeave={(e) => hideText(e, "status_quo")}
							onClick={(e) => setMenu("status_quo")}
						>
							<path
								className="sec_5_overlay path_overlay hover-tooltip"
								aria-describedby="tooltip-e"
								d="M 0 0 L -150 259.8076 A 300 300 0 0 0 150 259.8076 Z"
								fill="transparent"
							/>
						</a>
						<a
							onMouseOver={(e) => showText(e, "reporting")}
							onMouseLeave={(e) => hideText(e, "reporting")}
							onClick={(e) => setMenu("reporting")}
						>
							<path
								className="sec_6_overlay path_overlay hover-tooltip"
								aria-describedby="tooltip-f"
								d="M 0 0 L 150 259.8076 A 300 300 0 0 0 300 0 Z"
								fill="transparent"
							/>
						</a>
					</g>
					<circle
						cx="400"
						cy="400"
						r="100"
						fill="white"
						stroke="#1e4067"
						strokeWidth="1"
					></circle>

					<g
						className="arcs"
						id="arcs"
						transform=" translate(400 400) rotate(30) scale(1 -1)"
					>
						<text
							x="-60"
							y="5"
							fill="#1e4067"
							fontSize="1.3em"
							fontWeight="400"
							className="font-alt-text"
							transform="scale(+1,-1) rotate(-30)"
						>
							<tspan dy="0em">ESG Advisory</tspan>
						</text>
					</g>
				</svg>
			</div>
		</div>
	);
}
